export const getInteractionsLogsUrl = (locationId: string, agentId: string) =>
  `/business/locations/${locationId}/agents/${agentId}/interactions`;

export const getInteractionLogUrl = (locationId: string, agentId: string, id: number) =>
  `/business/locations/${locationId}/agents/${agentId}/interactions/${id}`;

export const getBusinessInteractionLogUrl = (id: number) => `/business/interactions/${id}`;

export const getAssociatedRecordsUrl = (contactId: number) =>
  `/business/contacts/${contactId}/integration_entities/contacts`;
